<ion-app>
  <ion-router-outlet [swipeGesture]="false" [animated]="false"></ion-router-outlet>
  <app-floating-buttons></app-floating-buttons>
  <div class="connection-banner" *ngIf="connectionState() !== 'connected'" role="status" aria-live="polite">
    <span>{{ connectionMessage() }}</span>
    <ion-button *ngIf="connectionState() === 'unavailable'" size="small" fill="clear" (click)="retryConnection()">再接続</ion-button>
  </div>
</ion-app>
